import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { useLocale } from "next-intl"
import { useState } from "react"
import { LeftArrow, RightArrow } from "ui/icons"

import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/effect-fade"
import { Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import colors from "theme/colors"
import { NewText } from "ui"
import { extractProperty } from "utils"

import PersonItem from "./PersonItem"

const StyledWrapper = styled.div`
  margin-top: 24px;
`

const StyledArrowContainer = styled(Button)`
  &:disabled {
    svg {
      path {
        stroke: rgba(21, 62, 105, 0.3);
      }
    }
  }
`

const StyledArrowTextContainer = styled.div``

const StyledArrowsContainer = styled.div<{ $locale: string }>`
  display: flex;
  align-items: center;
  padding-top: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: ${(p) => (p.$locale === "en" ? "row-reverse" : "row")};
    justify-content: ${(p) => (p.$locale === "en" ? "flex-end" : "flex-start")};
  }
`

type PersonSwiperProps = {
  data: any
  isYellow: boolean
}

function PersonSwiper({ data, isYellow }: PersonSwiperProps) {
  const locale = useLocale()
  const [activeIndex, setActiveIndex] = useState<number>(1)
  return (
    <StyledWrapper>
      <Swiper
        key={1}
        style={{ padding: 0 }}
        modules={[Navigation]}
        navigation={{
          nextEl: locale === "en" ? `.arrow-right` : `.arrow-left`,
          prevEl: locale === "en" ? `.arrow-left` : `.arrow-right`,
        }}
        slidesPerView={"auto"}
        width={300}
        spaceBetween={20}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex + 1)}
      >
        {data.map((person: any, index: number) => {
          const name = extractProperty(person, "teamName")
          const role = extractProperty(person, "teamRole")

          const description = extractProperty(person, "teamDescription")

          const image = extractProperty(person, "teamImage")

          return (
            <SwiperSlide key={index.toString()} style={{ width: "300px" }}>
              <PersonItem
                localeLang={locale}
                image={image}
                title={name}
                role={role}
                description={description}
                color={colors.white}
                isYellow={isYellow}
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
      <StyledArrowsContainer
        style={{
          flexDirection: locale === "en" ? "row-reverse" : "row",
          justifyContent: locale === "en" ? "flex-end" : "flex-start",
        }}
        $locale={locale}
      >
        <StyledArrowContainer className={`arrow-right arrow`}>
          <RightArrow />
        </StyledArrowContainer>
        <StyledArrowTextContainer>
          <NewText
            desktopFontSize={14}
            component="p"
            desktopLineHeight="20px"
            desktopFontWeight="400"
            color={colors.darkGray}
          >
            {activeIndex}/{data.length}
          </NewText>
        </StyledArrowTextContainer>
        <StyledArrowContainer className={`arrow-left arrow`}>
          <LeftArrow />
        </StyledArrowContainer>
      </StyledArrowsContainer>
    </StyledWrapper>
  )
}

export default PersonSwiper
